
<mat-form-field [appearance]="config?.appearance || 'standard'">
    <mat-label> {{ config?.label || '' }} </mat-label>
    <mat-select [formControl]="relativeDateFC" (selectionChange)="selection.emit($event)">
        <mat-option *ngFor="let option of options" [value]="selected || option?.value"> {{ option?.label || ''}} </mat-option>
    </mat-select>
</mat-form-field>